function normalizeApiBase(raw) {
  let base = (raw || 'http://localhost:5000').trim().replace(/\/+$/, '');
  // Code always appends `/api/...`; strip a trailing `/api` so we never call `/api/api/...`
  if (/\/api$/i.test(base)) base = base.replace(/\/api$/i, '');
  return base;
}

const API_BASE = normalizeApiBase(process.env.REACT_APP_API_URL);

export default API_BASE;
